import { useState, useRef } from "react";
import BlueprintHover from "../landing/BlueprintHover";
import { SectionLabel, Reveal, NC, HEADSHOT_URL, scrollToId } from "../landing/shared";
import { APPLY_CTA_LABEL } from "./config";

const CREDS = [
  ["COMPANY", "Shoreline Mortgage Group"],
  ["NMLS#", "1425493"],
  ["CO. NMLS#", null],
  ["LICENSED IN", "Florida, Pennsylvania"],
];

export default function ReplayHost() {
  const [hover, setHover] = useState(false);
  const [mouse, setMouse] = useState({ x: 0, y: 0 });
  const panelRef = useRef(null);
  const isFine = typeof window !== "undefined" && window.matchMedia("(pointer: fine)").matches;

  const onMove = (e) => {
    const r = panelRef.current.getBoundingClientRect();
    setMouse({ x: ((e.clientX - r.left) / r.width - 0.5) * 2, y: ((e.clientY - r.top) / r.height - 0.5) * 2 });
  };

  return (
    <section id="host" className="py-24 lg:py-36 px-6 lg:px-10 bg-[#00224F]/30" data-testid="replay-host-section">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <SectionLabel n="004" text="YOUR HOST" />
        </Reveal>
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <Reveal>
            <div
              ref={panelRef}
              onMouseEnter={() => isFine && setHover(true)}
              onMouseLeave={() => setHover(false)}
              onMouseMove={isFine ? onMove : undefined}
              className={`relative bg-[#00224F] border border-white/10 overflow-hidden ${!isFine ? "pulse-accent border-[#0162CA]/60" : ""}`}
              style={{ aspectRatio: "4/5" }}
              data-testid="replay-host-portrait-panel"
            >
              <img
                src={HEADSHOT_URL}
                alt="Josh Bartlett, Branch Manager, Shoreline Mortgage Group"
                className="absolute inset-0 w-full h-full object-cover transition-opacity duration-500"
                style={{ opacity: hover ? 0.25 : 1 }}
              />
              <div
                className="absolute inset-0 transition-opacity duration-500 pointer-events-none"
                style={{
                  opacity: hover ? 1 : 0,
                  background: "radial-gradient(circle at center, rgba(1,98,202,0.35) 0%, transparent 70%)",
                }}
              />
              {isFine && <BlueprintHover active={hover} mouse={mouse} />}
              <span className="reg-mark top-3 left-3 border-t-2 border-l-2" />
              <span className="reg-mark top-3 right-3 border-t-2 border-r-2" />
              <span className="reg-mark bottom-3 left-3 border-b-2 border-l-2" />
              <span className="reg-mark bottom-3 right-3 border-b-2 border-r-2" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <h2 className="font-black uppercase text-3xl md:text-4xl tracking-tight leading-tight">
              SOMEONE WHO TAKES THE TIME TO LOOK AT THE WHOLE FILE.
            </h2>
            <div className="h-px bg-[#0162CA] w-20 my-8" />
            <div className="space-y-5 text-white/65 text-[15px] leading-[1.8]">
              <p>
                I'm Josh Bartlett, Branch Manager at Shoreline Mortgage Group, with 20+ years in and around the
                mortgage industry, serving buyers in Florida and Pennsylvania.
              </p>
              <p>
                I built the Better Deal Method™ because buyers kept arriving with a quote and no explanation of how
                the rest of the transaction fit together. I'm known for taking time on files where the structure is
                the actual question — where the answer lives in how the pieces interact, not in one number.
              </p>
              <p>
                Here's what the review is and isn't: it's a conversation about your situation and your responsible
                next step. It's not an approval, not a rate quote, and not a commitment to lend. And "prepare and
                wait" is a legitimate outcome — if that's the honest answer, that's the answer you'll get.
              </p>
            </div>
            <div className="grid grid-cols-2 border border-[#404653]/50 mt-10">
              {CREDS.map(([label, value], i) => (
                <div key={label} className={`p-4 ${i % 2 === 0 ? "border-r" : ""} ${i < 2 ? "border-b" : ""} border-[#404653]/50`}>
                  <p className="font-mono-strict text-[10px] tracking-[0.25em] text-white/35 mb-1.5">{label}</p>
                  <p className="text-sm font-semibold">{value || <NC label="COMPANY NMLS" />}</p>
                </div>
              ))}
            </div>
            <div className="mt-8">
              <button type="button" data-cursor="cta" data-testid="replay-host-cta" onClick={() => scrollToId("apply")} className="cta-btn">
                {APPLY_CTA_LABEL}
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
